// @ts-nocheck
import React, { useContext, useState } from 'react';
import { usePopper } from 'react-popper';
import { useKeyPress } from '@lmig/lmds-react-date-picker/dist/useKeyPress';
import { useClickOutside } from '@lmig/lmds-react-date-picker/dist/useClickOutside';
import { HeaderNavigationContext } from '../../context/HeaderNavigationContext';
import { popperCustomOffset, popperMatchHeaderWidth } from '../../utils';
import debounce from 'lodash.debounce';
import { isPL } from 'Foundation/Configurations/GlobalConfiguration';
import { redirectTo } from 'Utilities/NavigationHelper';

/**
 * This component is used within the `HeaderParentItem` if the nav items should are **not** display within an overlay.
 * @memberof Internal-Component
 */
export const ParentItemDropdown = ({
  id,
  className,
  labelVisual,
  children,
  href,
  onClick,
  ...rest
}: any): JSX.Element => {
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
  const { activeMenuID, setActiveMenuID } = useContext(HeaderNavigationContext);

  const isOpen = activeMenuID === id;
  const brand = isPL() ? 'pl' : 'bl';

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom',
    modifiers: [
      popperMatchHeaderWidth,
      { name: 'offset', options: { offset: popperCustomOffset } },
      {
        name: 'flip',
        options: {
          fallbackPlacements: [],
        },
      },
    ],
  });
  const toggleMenu = (): void => {
    setActiveMenuID(id);
  };

  /** Checks to see if the user is clicking on the button toggle as well before toggling */
  const handleLocalClick = (event: MouseEvent): void => {
    const { target } = event;
    const clickedToggleButton =
      target instanceof Element &&
      target.closest('.lmig-FloatingHeader-dropdown-button');

    if (clickedToggleButton) {
      return;
    }

    if (referenceElement && !referenceElement.contains(target as Node)) {
      toggleMenu();
    }
  };

  useClickOutside(popperElement, handleLocalClick, isOpen);
  useKeyPress('Escape', toggleMenu, isOpen);

  return (
    <li id={id} className={className} {...rest}>
      <button
        ref={setReferenceElement}
        className={`lm-Link lmig-FloatingHeader-dropdown-button`}
        onClick={() => {
          toggleMenu();
        }}
        id={`${labelVisual}-button`}
      >
        {labelVisual}
      </button>
      {isOpen && (
        <div
          style={styles.popper}
          {...attributes.popper}
          ref={setPopperElement}
          className="lmig-FloatingHeader-dropdown-menu"
          role="menu"
          id={`${labelVisual}-content`}
        >
          {children}
        </div>
      )}
    </li>
  );
};
